<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入名称"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select class="mr10" v-model="type" placeholder="请选择" size="small">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="190px" align="center" label="培训封面">
        <template #default="scope">
          <el-image
            fit="cover"
            class="cover"
            v-if="scope.row.cover"
            :src="$utils.fileUrl(scope.row.cover)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.cover)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="培训名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="remark"
        label="报名说明"
      ></el-table-column>
      <el-table-column prop="companyName" label="发布者" align="center">
      </el-table-column>
      <el-table-column prop="username" align="center" label="发布时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.createTime, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="培训类型">
        <template #default="">
          <span>视频课程</span>
        </template>
      </el-table-column>
      <el-table-column label="公开类型" align="center">
        <template #default="scope"
          >{{ scope.row.type === 1 ? "公开课" : "私教课" }}
        </template>
      </el-table-column>
      <el-table-column label="链接地址" align="center">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="player(scope.row)"
            >播放视频</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="审核操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleEdit(scope.row.id, 1)"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="handleEdit(scope.row.id, 2)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 播放视频 -->
    <el-dialog
      title="视频播放"
      v-model="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="video" v-if="dialogVisible">
        <Aliplayer :source="itemData.video"></Aliplayer>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Aliplayer from "./../../../components/Aliplayer";
export default {
  components: { Aliplayer },
  data() {
    return {
      data: {},
      type: "",
      searchName: "",
      options: [
        { label: "全部", value: 0 },
        { label: "公开课", value: 1 },
        { label: "私教课", value: 2 },
      ],
      dialogVisible: false,
    };
  },
  methods: {
    async getData(page) {
      const params = {
        ident: 0,
        searchName: this.searchName,
        type: this.type,
        currentPage: page,
        pageSize: 20,
      };
      this.$loading.start();
      const res = await this.$api.train.review.getData(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(id, status) {
      if (!this.loading) {
        const text =
          status === 1 ? "是否确认通过审核？" : "是否确认不通过审核？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
              auditStatus: status,
            };
            const res = await this.$api.train.review.setData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              if (status === 1) {
                this.$message.success("通过成功");
              } else {
                this.$message.success("驳回成功！");
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    // 提交审核
    async companyAudit(params) {
      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        const res = await this.$api.train.review.setData(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.getData(this.data.current);
          this.editVisible = false;
          this.reject_dialog = false;
          this.auditRemark = "";
          if (params.status === 1) {
            this.$message.success("审核通过已通知该用户！");
          } else {
            this.$message.success("驳回成功！");
          }
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    player(data) {
      if (data.video === null) {
        this.$message.warning("视频还在转码中请稍后再试");
      } else {
        this.itemData = data;
        this.dialogVisible = true;
      }
    },
  },
  created() {
    this.getData();
  },
  
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.video {
  height: 500px;
}
</style>